import React from 'react';

export default class Tabs extends React.Component {
  generateTabs() {
    if (!this.props.tabs || !this.props.tabs.length) return [];
    return this.props.tabs.reduce((r, d, i, a) => {
      r.push(
        <div
          className={`tab ${d.active ? 'active' : ''}`}
          onClick={() => d.onClick()}
          key={typeof d.display === 'object' ? i : d.display}
        >
          {d.display}
        </div>
      );
      return r;
    }, []);
  }

  render() {
    return (
      <div className={`tabs ${this.props.center ? 'center' : ''}`} style={this.props.style}>
        {this.generateTabs()}
      </div>
    );
  }
}
